import { createApi } from '@reduxjs/toolkit/query/react';
import customFetchBase from '@/app/common/utils/customFetchBase';
import { getBaseApiPath } from '@/app/common/api/config';
import type {
  CheckAccessRequest,
  CheckAccessResponse,
  CheckBudgetResponse,
  CheckRemainingResponse,
  DomainSlugArg
} from '@/app/common/api/types/accessLevelApiTypes';

const accessLevelApi = createApi({
  reducerPath: 'accessLevelApi',
  baseQuery: (...args: unknown[]) =>
    customFetchBase(getBaseApiPath(), ...args),
  tagTypes: ['AccessLevel', 'Budget', 'Remaining'],
  endpoints: build => ({
    checkAccess: build.query<CheckAccessResponse, CheckAccessRequest>({
      query: ({ domain_slug, tool_name }) => ({
        url: '/go_handler/v2/access_levels/check_access_to_tools',
        method: 'POST',
        body: {
          domain_slug,
          tool_name
        }
      }),
      providesTags: ['AccessLevel']
    }),
    checkRemaining: build.query<CheckRemainingResponse, DomainSlugArg>({
      query: domain_slug => ({
        url: '/go_handler/v2/order/get_remaining_days_from_panel',
        method: 'POST',
        body: {
          domain_slug
        }
      }),
      providesTags: ['Remaining']
    }),
    checkBudget: build.query<CheckBudgetResponse, DomainSlugArg>({
      query: domain_slug => ({
        url: '/go_handler/v2/budget/get2',
        method: 'POST',
        body: {
          domain_slug
        }
      }),
      providesTags: ['Budget']
    }),
    checkBudgetOld: build.query<CheckBudgetResponse, DomainSlugArg>({
      query: domain_slug => ({
        url: '/go_handler/v2/budget/get',
        method: 'POST',
        body: {
          domain_slug
        }
      }),
      providesTags: ['Budget']
    })
  })
});

export const {
  useCheckAccessQuery,
  useLazyCheckAccessQuery,
  useCheckBudgetQuery,
  useCheckRemainingQuery,
  useCheckBudgetOldQuery
} = accessLevelApi;

export default accessLevelApi;
